module.exports = __webpack_public_path__ + "media/images/mes_180_cms-24fb8740b421ecb3cfb0ee917aa28bb9.png";